GetDomain();
async function GetDomain() {
  await fetch("config.json").then((response) => {
    response.json().then((settings) => {
        localStorage.setItem("$$$", settings.apiDomain as string);
        localStorage.setItem("$$$$", settings.merchantPortalDomain as string);
    });
  });
}

let apiDomain = localStorage.getItem("$$$");

export const ApiService = {
  dashboard: {
    balances: apiDomain + "reports/balances",
    statistics: apiDomain + "reports/statistics?day=",
    top10: apiDomain + "reports/top10",
  },
  merchant: {
    create: apiDomain + "merchants/create",
  },
  sso: {
    validateToken: "authenticate?token=",
  },
  category: {
      getCategory: apiDomain + "merchantBiller/categories",
    },
  biller: {
      getBiller: apiDomain + "merchantBiller/billers",
      saveBiller: apiDomain + "merchantBiller/exclude",
      getAllBillers: apiDomain + "billers/all",
      getMerchantBillers: apiDomain + "merchantBiller/excluded"
    },
  product: {
      getProduct: apiDomain + "merchantBiller/products",
      productSearch: apiDomain + "products/search"
    },
  merchantCommission: {
      getmerchantcommission: apiDomain + "merchantCommissions/all",
    },
  permissions: {
      getPermissions: apiDomain + "permissions/all",
    },
    roles: {
      getRoles: apiDomain + "roles/all",
      createRole: apiDomain + "roles/create",
      updateRole: apiDomain + "roles/update/",
      deleteRole: apiDomain + "roles/delete/",
    },
    users: {
      getUser: apiDomain + "users/all",
      createUsers: apiDomain + "users/create",
      updateUsers: apiDomain + "users/update/",
      toggleUserStatus: apiDomain + "users/toggleUserStatus/",
      getLoggedInUser: apiDomain + "users/info"
    },
    settings: {
      getKeys: apiDomain + "merchants/merchantSettings",
      resetKeys: apiDomain + "merchants/resetApiKeys",
      walletAlert: apiDomain + "wallets/updateWalletLimit",
      viewWalletLimit: apiDomain + "wallets/viewWalletLimit",
      changeTransactionPin: apiDomain + "pin/change",
      resetPin: apiDomain + "pin/reset"

    },
    wallet: {
      getWalletTransactions: apiDomain + "wallets/transactions",
      getWalletCommission: apiDomain + "walletCommissions/transactions",
      commissionTransfer: apiDomain + "wallets/transferCommission",
      walletSearch: apiDomain + "wallets/searchTransactions",
      walletCommissionSearch: apiDomain + "walletCommissions/searchTransactions"
    },
    reports: {
      getReports: apiDomain + "reports/transactions",
      reportSearch: apiDomain + "reports/searchTransactions",
      settlementSearch: apiDomain + "reports/searchSettlement",
      receipt: apiDomain + "receipt/",
      getMerchantSettlement: apiDomain + "reports/settlement"
    },
    auditLog: {
      getAuditLog: apiDomain + "auditLogs/all",
      auditLogSearch: apiDomain + "auditLogs/search"
    },
    kycTier: {
      getKycTier: apiDomain + "kycTiers/all"
    },
    profile: {
      updateProfile: apiDomain + "merchants/update",
      kycForm: apiDomain + "merchants/kyc"
    },
    transaction: {
      getTransactionCategory: apiDomain + "merchantBiller/categories",
      getTransactionBiller: apiDomain + "merchantBiller/billers?",
      getTransactionProduct: apiDomain + "merchantBiller/products?",
      makePayment: apiDomain + "pay",
      lookUp: apiDomain + "lookup"
    },
    pin: {
      verify: apiDomain + "pin/verify",
      create: apiDomain + "pin/create",
    },
    bulk: {
      getAllBulk: apiDomain + "bulk/airtime/all",
      getSingleAirtimeBulk: apiDomain + "bulk/airtime/all/",
      performBulkAirtime: apiDomain + "bulk/airtime/upload"
    },
    dailyReport: apiDomain + "dailyReport/push?day="
};
